/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.5.0-nightly.2026.7.24",
    versionName: "0.5.0-nightly.2026.7.24",
    versionChannel: "nightly",
    buildDate: "2026-07-24T00:25:16.021Z",
    commitHash: "99a3862a8949642de26157b86add9203c9ed7975",
};
